import {observer} from "mobx-react-lite";
import React, { useRef, useEffect } from "react";
import { PlanStore } from "../../../../subscription-plans/stores/subscription-plans-store";
import "./onboarding-plan-description.scss";
import IconNext from "../../../../../components/icons/icon-next/icon-next";
import { ButtonIcon } from "../../../../../components/inputs/button-icon/button-icon";
import FontBody1 from "../../../../../components/fonts/font-body1/font-body1";
import { FONT_COLOR, FONT_VARIANT } from "../../../../../components/fonts/font-props";

export interface IPlanDescription {
    plan: PlanStore;
    isExpanded: boolean;
    onToggle: () => void;
}

const OnboardingPlanDescription: React.FC<IPlanDescription> = observer(({ plan, isExpanded, onToggle }) => {
    const wrapperRef = useRef<HTMLDivElement>(null);

    useEffect(() => {
        if (isExpanded && wrapperRef.current) {
            wrapperRef.current.scrollIntoView({ behavior: "smooth", block: "end" });
        }
    }, [isExpanded]);

    return (
        <div className="onboarding-plan-description-wrapper" ref={wrapperRef}>
            <div
                className={`onboarding-plan-description${isExpanded ? " expanded" : " collapsed"}`}
                dangerouslySetInnerHTML={{ __html: plan.plan_description ?? "" }}
            />
            <div
                className={`onboarding-plan-description-toggle ${isExpanded ? 'expanded' : 'collapsed'}`}
                onClick={onToggle}
            >
                <FontBody1 color={FONT_COLOR.ACCENT1} variant={FONT_VARIANT.BOLD}>
                    {isExpanded ? "Hide full list" : "See full feature list"}
                </FontBody1>
                <div className="toggle-icon">
                    <ButtonIcon
                        Component={IconNext}
                        onClick={onToggle}
                    />
                </div>
            </div>
        </div>
    );
});

export default OnboardingPlanDescription;